import { KebabHorizontalIcon, PencilIcon, PlusIcon, SyncIcon, TrashIcon } from "@primer/octicons-react";
import { ActionList, ActionMenu, Box, Checkbox, useConfirm } from "@primer/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/ui/button";
import DataTable from "../../../components/ui/data-table";
import { useCommonSelectedHook } from "../../../hooks/useCommonSelectedHook";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { actions } from "../../../state/actions/actionsWrapper";

import Text from "../../../components/ui/text";
import { useCommonContext } from "../../../contexts/common";
import { IDmNguonBietToi } from "../../../models/response/category/IDmNguonBietToi";
import { RootState } from "../../../state/reducers";
import NguonBietToiEditModal from "./NguonBietToiEditModal";

const NguonBietToiPage = () => {
    const { status, nguonBietTois, isShowEditModal, editingData } = useSelector((x: RootState) => x.crmCategoryWrapper.nguonBietToi)
    const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
    const { translate } = useCommonContext();
    const confirm = useConfirm();
    const dispatch = useDispatch();
    useEffect(() => {
        if (status === ePageBaseStatus.is_not_initialization || status === ePageBaseStatus.is_need_reload) {
            handleReload();
        }
    }, [status])
    const handleReload = () => {
        dispatch(actions.crmCategoryWrapper.nguonBietToi.LOAD_START(''))
    }
    const handleDelete = async (id: number) => {
        if (await confirm({
            content: translate("Base.Label.DeleteConfirm.Content"),
            title: translate("Base.Label.Confirm"),
            cancelButtonContent: translate("Base.Label.Close"),
            confirmButtonContent: translate("Base.Label.Delete"),
            confirmButtonType: "danger"
        })) {
            dispatch(actions.crmCategoryWrapper.nguonBietToi.DELETE_START(id))
        }
    }

    return (
        <Box sx={{
            p: 3
        }}>
            <DataTable
                data={nguonBietTois}
                isLoading={status === ePageBaseStatus.is_loading}
                title={translate("NguonBietToi.Caption")}
                searchEnable
                paging={{ enable: true }}
                actionComponent={
                    <Box sx={{
                        display: "flex"
                    }}>
                        <Button text="Base.Label.AddNew" leadingVisual={PlusIcon}
                            size="medium"
                            variant="primary"
                            onClick={() => {
                                dispatch(actions.crmCategoryWrapper.nguonBietToi.SHOW_EDIT_MODAL(undefined))
                            }}
                        />
                        <Button text="Base.Label.Refresh" leadingVisual={SyncIcon}
                            size="medium"
                            sx={{ ml: 1 }}
                            onClick={() => {
                                handleReload();
                            }}
                        />
                    </Box>
                }
                columns={[
                    {
                        id: "cmd",
                        caption: "#",
                        width: "50px",
                        align: "center",
                        cellRender: (data: IDmNguonBietToi) => {
                            return (
                                <ActionMenu>
                                    <ActionMenu.Button icon={KebabHorizontalIcon} variant="invisible" sx={{ m: -1 }}>&nbsp;</ActionMenu.Button>
                                    <ActionMenu.Overlay width="auto">
                                        <ActionList>
                                            <ActionList.Item onSelect={() => {
                                                dispatch(actions.crmCategoryWrapper.nguonBietToi.SHOW_EDIT_MODAL(data))
                                            }}>
                                                <ActionList.LeadingVisual><PencilIcon /></ActionList.LeadingVisual>
                                                <Text text='Base.Label.Edit' />
                                            </ActionList.Item>
                                            <ActionList.Item variant="danger" onSelect={() => {
                                                handleDelete(data.id)
                                            }}>
                                                <ActionList.LeadingVisual><TrashIcon /></ActionList.LeadingVisual>
                                                <Text text='Base.Label.Delete' />
                                            </ActionList.Item>
                                        </ActionList>
                                    </ActionMenu.Overlay>
                                </ActionMenu>
                            );
                        }
                    },
                    {
                        dataField: "name",
                        caption: translate("NguonBietToi.Name"),

                    },
                    {
                        dataField: "name_en",
                        caption: translate("NguonBietToi.NameEn"),

                    },
                    {
                        dataField: "nguonbiettoi_type",
                        caption: translate("NguonBietToiType.Name"),
                    },
                    {
                        dataField: "viet_tat",
                        caption: translate("Code"),
                        width: 200
                    },
                    {
                        dataField: "is_show_campaign",
                        width: 250,
                        caption: translate("NguonBietToi.is_show_campaign"),
                        cellRender: (data: IDmNguonBietToi) => {
                            return (
                                <Box sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}>
                                    <Checkbox checked={data.is_show_campaign} />
                                </Box>
                            )
                        }
                    },

                ]}
            />
            {isShowEditModal &&
                <NguonBietToiEditModal />
            }
        </Box>
    );
};

export default NguonBietToiPage;